module.exports = __webpack_public_path__ + "static/media/6.Highlighted Spread.6760c6c3.jpg";